import React from 'react';
import { Spinner } from 'reactstrap';
import { Content, ItemsCount, LoadingDiv, StyleKanbanWarning } from '../styles';
import { Header, Bloco } from './styles';
import OrderAndamentoDelivery from '../../Items/OrderAndamentoDelivery';
import { EveryOrdersDelivery } from 'components/EveryOrdersDelivery';

export default function CardOrdersSchedulingAndamento({
  baskets,
  handleItemFinished,
  handleCancelItem,
  loading,
  handleItemReady,
  handleUpdate,
  countOrders,
  hasOrderActive,
}) {
  const basketsFiltered = baskets?.filter(
    (order) => order.table.table_type === 'delivery'
  );

  const basketId = basketsFiltered
    .flatMap((bskt) => bskt)
    .map((baskets) => {
      return baskets.basket.id;
    });

  const basketIfood = basketsFiltered
    .flatMap((bskt) => bskt)
    .map((baskets) => {
      return baskets.basket.ifood_id;
    });

  const basketWithdrawal = basketsFiltered
    .flatMap((bskt) => bskt)
    .map((baskets) => {
      return baskets.with_withdrawal;
    });

  return (
    <Bloco>
      <Header>
        EM ANDAMENTO
        <ItemsCount style={{ color: '#ffa50b' }}>{countOrders}</ItemsCount>
      </Header>
      <Content>
        {loading ? (
          <LoadingDiv>
            <Spinner color="warning" />
          </LoadingDiv>
        ) : (
          baskets
            ?.filter((order) => order?.scheduled_to)
            .map((item) => (
              <OrderAndamentoDelivery
                key={item.basket.id}
                handleCancelItem={handleCancelItem}
                handleItemFinished={handleItemFinished}
                item={item}
                handleItemReady={handleItemReady}
                handleUpdate={handleUpdate}
              />
            ))
        )}

        {!hasOrderActive && (
          <StyleKanbanWarning>
            <p style={{ color: '#666666' }}>Não há pedido</p>
            <p style={{ color: '#666666' }}>no momento</p>
          </StyleKanbanWarning>
        )}
      </Content>

      <EveryOrdersDelivery
        baskets={basketsFiltered}
        basketId={basketId}
        basketStatus={['accepted']}
        basketIfood={basketIfood}
        basketWithdrawal={basketWithdrawal}
      />
    </Bloco>
  );
}
